var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { stringify } from 'query-string';
export const apiKeysDataProvider = context => {
    return {
        getList: async ({ applicationUuid, filter = {}, pagination = { page: 1, perPage: 24 }, sort = null, }) => {
            const basePath = `${context.apiUrl}/api-management/1.0/applications/${applicationUuid}/api-keys`;
            const url = `${basePath}?${stringify(Object.assign(Object.assign(Object.assign({}, filter), { page: pagination.page - 1, size: pagination.perPage }), (sort && { sort: `${sort.field},${sort.order}` })))}`;
            const { json } = await context.fetchJson(url, {
                credentials: 'include',
            });
            return {
                data: json.results.map((_a) => {
                    var { apiKey } = _a, item = __rest(_a, ["apiKey"]);
                    return (Object.assign({ id: apiKey, apiKey }, item));
                }) || [],
                total: json.totalElements || 0,
            };
        },
    };
};
//# sourceMappingURL=apiKeys.js.map